'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ref;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var developer = _react2.default.createElement(_radium.Style, {
  name: 'developer',
  scopeSelector: _constants.QUERY_SELECTORS.PRESENTATION + '.developer',
  rules: (_ref = {
    fontFamily: 'monospace',
    background: '#222',
    color: 'white'

  }, _defineProperty(_ref, _constants.QUERY_SELECTORS.SLIDE, {
    padding: '2em'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.SLIDE_INDEX, {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    textAlign: 'right',
    fontSize: '1.5em'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.COVER, {}), _defineProperty(_ref, _constants.QUERY_SELECTORS.H1, {
    margin: '0 20px 30px 20px',
    fontSize: '4em',
    color: '#f44'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.H2, {
    margin: '0 20px 30px 20px',
    fontSize: '2em',
    color: '#fdd'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.P, {
    margin: '10px 20px',
    fontSize: '2em'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.LI, {
    fontSize: '2em',
    marginLeft: '1em',
    marginBottom: '1em'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.CODE, {
    margin: '10px 20px'
  }), _ref)
});

exports.default = developer;


/*****************
 ** WEBPACK FOOTER
 ** ../lib/themes/developer.js
 ** module id = 139
 ** module chunks = 0
 **/